
import React from 'react';
import { MessageCircleQuestion } from 'lucide-react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const faqItems = [
  {
    question: "Is there a free trial?",
    answer: "Yes, we offer a risk-free 30-day free trial that you can cancel right in your dashboard at anytime."
  }, 
  {
    question: "Do I need my own API key?",
    answer: "Yes, you will need to bring your own API key for AI usage. This gives you full control over your AI model selection and usage."
  }, 
  {
    question: "Can I switch plans later?",
    answer: "Yes, you can upgrade or downgrade at any time in your dashboard. Changes take effect immediately."
  }, 
  {
    question: "Does AskSpot integrate with my CRM?",
    answer: "Yes, AskSpot connects via webhooks to CRMs, Google Sheets, and automation tools, making it easy to integrate with your existing workflow."
  }
];

const PricingFAQ = () => {
  return <div className="max-w-3xl mx-auto">
      <div className="text-center mb-12">
        <div className="inline-flex items-center justify-center gap-2 mb-4">
          <MessageCircleQuestion className="text-[#003a70] h-6 w-6" />
          <h2 className="md:text-3xl font-bold text-[#003a70] text-3xl">
            Still Have Questions? We've Got Answers
          </h2>
        </div>
      </div>
      
      <Accordion type="single" collapsible className="w-full">
        {faqItems.map((item, index) => <AccordionItem key={index} value={`item-${index}`} className="border border-gray-200 rounded-lg mb-4 bg-white shadow-sm hover:shadow-md transition-shadow">
            <AccordionTrigger className="px-5 py-4 text-left font-medium text-lg text-[#003a70]">
              {item.question}
            </AccordionTrigger>
            <AccordionContent className="px-5 pb-4 text-gray-600">
              {item.answer}
            </AccordionContent>
          </AccordionItem>)}
      </Accordion>
    </div>;
};

export default PricingFAQ;
